import React from "react";
import BaseWineSearchBar from "../../components/global/SearchBar/BaseWineSearchBar";
import Header from "../../components/layout/Header/Header";
import Layout from "../../components/layout/Layout/Layout";
import WineDetail from "../../components/global/Wines/WineDetail";
import { getBaseWine, getBasewineFromWineSlug } from "../../lib/wineRequests";
import { withUserSSR } from "../../utils/withUserSSR";

export default function WinePage({ baseWine, error, vintage }) {
  return (
    <Layout>
      <Header />
      <BaseWineSearchBar className="pb-8" hideResults={true} />
      <WineDetail baseWine={baseWine} error={error} vintage={vintage}/>
    </Layout>
  );
}

export const getServerSideProps = withUserSSR(async (context) => {
  const { slug } = context.params;
  const requestedSlug = Array.isArray(slug) ? slug[0] : slug;
  let baseWineSlug = null;
  let baseWineVintage = null;

  if (!requestedSlug) {
    return {
      props: {
        error: "Failed to fetch base wine data",
      },
    };
  }

  try {
    // Try resolving an incoming wine slug to its base wine slug.
    const { data } = await getBasewineFromWineSlug(requestedSlug as string);
    baseWineSlug = data?.base_wine_slug as string;
    baseWineVintage = data?.base_wine_vintage as number;
  } catch (error) {
    if (error.status !== 404) {
      return {
        props: {
          error: "Failed to fetch base wine data",
        },
      };
    }
  }

  const finalSlug = baseWineSlug || requestedSlug;

  try {
    // Forward the visitor's session so subscribers get full tasting notes.
    const { data } = await getBaseWine(finalSlug, undefined, undefined, context.req.headers.cookie || "");

    return {
      props: {
        baseWine: data,
        vintage: baseWineVintage ? Number(baseWineVintage) : null,
      },
    };
  } catch (error) {
    const errorMessage = error.status === 404
      ? `Unable to load Wine Reviews for slug ${finalSlug}`
      : "Failed to fetch base wine data";

    return {
      props: {
        error: errorMessage,
      },
    };
  }
});
